import { ProfileActionType as ActionType } from 'src/stores/action-types/profileActionType'
import { ProfileAction as Action } from 'src/stores/actions/profileActions'

export type ProfileState = {
    profileId?: number
}

const initialProfile: ProfileState = {
    profileId: undefined
}

export const profileReducer = (state: ProfileState = initialProfile, action: Action): ProfileState => {
    switch (action.type) {
        case ActionType.SET_PROFILE:
            return {
                ...state,
                profileId: action.payload as number
            }

        default:
            return { ...state }
    }
}
